const creditCardIconName = cardType =>  {
  switch (cardType) {
    case 'visa':
      return 'visa';

    case 'visa_corporate':
      return 'visaCorporate';

    case 'visa_electron':
      return 'visaElectron';

    case 'visa_debit':
      return 'visa';

    case 'visa_corporate_debit':
      return 'visaCorporate';

    case 'visa_electron_debit':
      return 'visaElectron';

    case 'master_card':
      return 'mastercard';

    case 'master_card_debit':
      return 'mastercard';

    case 'master_card_corporate':
      return 'mastercardCorporate';

    case 'master_card_corporate_debit':
      return 'mastercardCorporate';

    case 'uatp':
      return 'uatp';

    case 'uatp_debit':
      return 'uatp';

    case 'amex':
      return 'amex';

    case 'amex_debit':
      return 'amex';

    case 'amex_corporate':
      return 'amexCorporate';

    case 'amex_corporate_debit':
      return 'amexCorporate';

    case 'diners_club':
      return 'dinersClub';

    case 'diners_club_debit':
      return 'dinersClub';

    case 'diners_club_corporate':
      return 'dinersClubCorporate';

    case 'diners_club_corporate_debit':
      return 'dinersClubCorporate';

    case 'discover':
      return 'discover';

    case 'discover_debit':
      return 'discover';

    case 'discover_corporate':
      return 'discoverCorporate';

    case 'discover_corporate_debit':
      return 'discoverCorporate';

    case 'jcb':
      return 'jcb';

    case 'jcb_debit':
      return 'jcb';

    default:
      return 'visa';
  }
}

export default creditCardIconName;
